import { Dictionary } from "flow/api/types";
import ICLICommand from "flow/interfaces/ICLICommand";
import $ from "jquery";

export default {
    name: "id-collision-check",
    description: "Checks for id collisions in the HTML DOM",
    options: [
        {
            name: "list",
            shortName: "l",
            description: "Lists all ids"
        }
    ],
    arguments: [],
    callback: (writer, optsAndArgs) => {
        const map: Dictionary<number> = {};
        $(document)
            .find("[id]")
            .each(function () {
                const id = $(this).attr("id");
                map[id] = (map[id] ? map[id] : 0) + 1;
            });

        const lines = [];

        for (const prop in map) {
            if (map[prop] > 1 || optsAndArgs.list) {
                lines.push(prop + ": " + map[prop]);
            }
        }

        if (lines.length > 0) {
            writer.output.writeLine(lines.join("\n"));
        } else {
            writer.output.writeLine("No id collisions detected in the current DOM.");
        }

        return { input: "" };
    }
} as ICLICommand;
